import genererGuid from '@/services/general/genererGuid';
import { TYPE_IMPRESSION, ETAT_TYPE_GENERE } from '@/configuration/bodac/besoin/besoinConfig';
import { UNITE } from '@/configuration/devisConf';

export default function genererBesoin(type = TYPE_IMPRESSION, commande = null) {
  return {
    tiersDestinataire: null,
    lieuLivraisonPrestation: null,
    produit: null,
    produitAchat: null,
    commandeAchat: null,
    formatAffiche: null,
    largeur: null,
    longueur: null,
    typeMaterielId: null,
    natureSupportAfficheId: null,
    produitAchatId: null,
    commandeId: commande?.id || null,
    libelle: commande?.theme || null,
    typeBesoin: type,
    quantite: 0,
    unite: UNITE,
    tiersDestinataireId: null,
    dateLivraison: null,
    lieuLivraisonPrestationId: null,
    commentaire: null,
    ligneCommandeAchatId: null,
    commandeAchatId: null,
    formatAfficheId: null,
    produitId: null,
    dateDepart: null,
    anneeSemaineDepart: null,
    nomVisuel: null,
    nbAfficheVendue: 0,
    nbAfficheMaintenance: 0,
    nbAfficheTotal: 0,
    etat: ETAT_TYPE_GENERE,
    key: genererGuid(),
    deleted: false,
    selected: false,
  };
}
